// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';

// Primereact imports
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// Styling
import './support.scss';

// Services
import SupportService from '../../redux/services/support';
import SuspensionService from '../../redux/services/suspension';
import QuoteService from '../../redux/services/quote';

// Utils
import { PRODUCT_CLOSE_SUSPENSION_NAME, PRODUCT_CLOSE_SUSPENSION_PRICE, PRODUCT_CLOSE_SUSPENSION_REF, PRODUCT_KEY_MESSAGE, PRODUCT_KEY_REASON, PRODUCT_KEY_SUSPENSION_DATE, PRODUCT_KEY_SUSPENSION_END_DATE, PRODUCT_KEY_SUSPENSION_TYPE, PRODUCT_SUSPENSION_CANCELLATION_NAME, PRODUCT_SUSPENSION_CANCELLATION_PRICE, PRODUCT_SUSPENSION_CANCELLATION_REF, PRODUCT_SUSPENSION_INVOICE_ITEM, REGISTRATION_STATE_SUSPENDED } from '../../common/constants';
import { getContactTypeList, getSuspensionReasonList, getSuspensionTypeList, isCloseSuspensionContactType, isReasonOther, isSuspensionContactType, SUSPENSION_REQUEST_OPTION, SUSPENSION_TYPE_CANCEL_OPTION, SUSPENSION_TYPE_SUSPENSION_OPTION } from '../../common/lists/support';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Redux
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { updateBasket } from '../../redux/actions/order';

class SupportPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            contactType: null,
            reason: null,
            reasonDetail: "",
            suspensionDate: null,
            message: "",
            activeSuspension: false,
            quoteFee: null,
            documentAttachment: null,
            documentAttachmentName: "",
            // Validation variables
            validContactType: true,
            validReason: true,
            validReasonDetail: true,
            validSuspensionDate: true,
            validMessage: true,
            validSuspension: true,
            validQuotePayment: true,
            validUploadFile: true,
            serverLoading: false
        };
    }

    componentDidMount() {
        SuspensionService.validateRegistrationSuspension(Number(this.props.ballot.ballotRef))
        .then((response) => { 
            this.setState({
                activeSuspension: response.activeSuspension
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.error"), life: 3000 });

            this.setState({
                serverLoading: false
            });
        });

        QuoteService.getAssociateMissingQuotesFees(this.props.associate.associateId)
        .then((response) => { 
            this.setState({
                quoteFee: response.quoteFee
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.error"), life: 3000 });

            this.setState({
                serverLoading: false
            });
        });
    }

    onChange(field, value) {
        this.setState({ [field]: value });
    }

    validateForm() {
        this.setState({ 
            validContactType: (this.state.contactType !== null),
            validSuspensionDate: ((!isSuspensionContactType(this.state.contactType) && !isCloseSuspensionContactType(this.state.contactType)) || this.state.suspensionDate !== null),
            validReason: (!isSuspensionContactType(this.state.contactType) || this.state.reason !== null),
            validReasonDetail: (!isSuspensionContactType(this.state.contactType) || (!isReasonOther(this.state.reason)  || this.state.reasonDetail !== "")),
            validMessage: (isSuspensionContactType(this.state.contactType) || isCloseSuspensionContactType(this.state.contactType) || this.state.message !== "")
        });

        if(isSuspensionContactType(this.state.contactType)) {
            this.setState({
                validSuspension: !this.state.activeSuspension
            });

            this.setState({
            validQuotePayment: this.state.quoteFee === null || (this.state.quoteFee !== null && this.state.quoteFee.delayMonths === 0)
            });
        }
        else {
            this.setState({
                validSuspension: true,
                validQuotePayment: true
            });
        }

        return ((this.state.contactType !== null) &&
                ((!isSuspensionContactType(this.state.contactType) && !isCloseSuspensionContactType(this.state.contactType)) || this.state.suspensionDate !== null) &&
                (!isSuspensionContactType(this.state.contactType) || this.state.reason !== null) &&
                (!isSuspensionContactType(this.state.contactType) || !this.state.activeSuspension) &&
                (!isSuspensionContactType(this.state.contactType) || (this.state.quoteFee === null || (this.state.quoteFee !== null && this.state.quoteFee.delayMonths === 0))) &&
                (!isSuspensionContactType(this.state.contactType)|| (!isReasonOther(this.state.reason) || this.state.reasonDetail !== "")) &&
                (isSuspensionContactType(this.state.contactType) || isCloseSuspensionContactType(this.state.contactType) || this.state.message !== "")
        );
    }

    submitSupportRequest() {
        if(this.validateForm()) {

            this.setState({
                serverLoading: true
            });

            if(isSuspensionContactType(this.state.contactType)) { 
                SuspensionService.validateRegistrationSuspension(Number(this.props.ballot.ballotRef))
                .then((response) => { 
                    if(response.activeSuspension) {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.active-suspension"), life: 3000 });
                        this.setState({
                            serverLoading: false
                        });
                    }
                    else {
                        this.submitRequestToServerV2();
                    }
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.error"), life: 3000 });
        
                    this.setState({
                        serverLoading: false
                    });
                });
            }
            else if(isCloseSuspensionContactType(this.state.contactType)) {
                SuspensionService.validateRegistrationCloseSuspension(Number(this.props.ballot.ballotRef))
                .then((response) => { 
                    if(response.activeCloseSuspension) {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.active-close-suspension"), life: 3000 });
                        this.setState({
                            serverLoading: false
                        });
                    }
                    else {
                        this.submitRequestToServerV2();
                    }
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.error"), life: 3000 });
        
                    this.setState({
                        serverLoading: false
                    });
                });
            }
            else {
                this.submitRequestToServerV2();
            }
        }
    }

    submitRequestToServerV2() {
        if(isSuspensionContactType(this.state.contactType)) {
            let metadata = [
                { key: PRODUCT_KEY_SUSPENSION_TYPE, value: this.state.contactType.code === SUSPENSION_REQUEST_OPTION.code ? SUSPENSION_TYPE_SUSPENSION_OPTION.code.toString() : SUSPENSION_TYPE_CANCEL_OPTION.code.toString() },
                { key: PRODUCT_KEY_SUSPENSION_DATE, value: this.state.suspensionDate.toISOString() },
                { key: PRODUCT_KEY_REASON, value: !isReasonOther(this.state.reason) ? this.state.reason.name : this.state.reasonDetail },
                { key: PRODUCT_KEY_MESSAGE, value: this.buildTicketMessage() },
            ];

            // Add product to basket
            let product = {
                productRef: PRODUCT_SUSPENSION_CANCELLATION_REF,
                title: this.props.t("products.products." + PRODUCT_SUSPENSION_CANCELLATION_NAME),
                price: null,
                metadata: metadata
            };

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);

            window.open(process.env.PUBLIC_URL + "/checkout", "_self");
        }
        else if(isCloseSuspensionContactType(this.state.contactType)) { 
            let metadata = [
                { key: PRODUCT_KEY_SUSPENSION_END_DATE, value: this.state.suspensionDate },
                { key: PRODUCT_KEY_MESSAGE, value: this.buildTicketMessage() },
            ];

            // Add product to basket
            let product = {
                productRef: PRODUCT_CLOSE_SUSPENSION_REF,
                title: this.props.t("products.products." + PRODUCT_CLOSE_SUSPENSION_NAME),
                price: PRODUCT_CLOSE_SUSPENSION_PRICE,
                invoiceItem: PRODUCT_SUSPENSION_INVOICE_ITEM,
                metadata: metadata
            };

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);   
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);

            window.open(process.env.PUBLIC_URL + "/checkout", "_self");
        }
        else {
            SupportService.submitSupportRequest({
                email: this.props.associate.personalData.email,
                contactType: this.state.contactType.code,
                message: this.buildTicketMessage(),
                attachment: this.state.documentAttachment === null ? null : {
                    filename: this.state.documentAttachmentName,
                    content: this.state.documentAttachment,
                    mimeType: "application/pdf"
                }
            })
            .then((response) => {
                this._toast.current.show({ severity: 'success', detail: this.props.t("support.messages.success"), life: 5000 });

                this.setState({
                    serverLoading: false
                });
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("support.messages.error"), life: 3000 });
    
                this.setState({
                    serverLoading: false
                });
            });
        }
    }

    buildTicketMessage() {

        // Build full address
        var address = "";

        if(this.props.associate.personalData.streetTypePlaceholder !== null) {
            address += this.props.associate.personalData.streetTypePlaceholder;
        }

        if(this.props.associate.personalData.addressLine !== null) {
            address += " " + this.props.associate.personalData.addressLine;
        }

        if(this.props.associate.personalData.doorNumber !== null) {
            address += " " + this.props.associate.personalData.doorNumber;
        }

        if(this.props.associate.personalData.doorFloor !== null) {
            address += " " + this.props.associate.personalData.doorFloor;
        }

        var suspensionDate = this.state.suspensionDate < new Date() ? new Date() : this.state.suspensionDate;

        // Build ticket message
        if(isSuspensionContactType(this.state.contactType)) {
            var dd = String(suspensionDate.getDate()).padStart(2, '0');
            var mm = String(suspensionDate.getMonth() + 1).padStart(2, '0');
            var yyyy = suspensionDate.getFullYear();

            return this.props.t("support.form.suspension-message-part-1") + this.props.associate.personalData.name + this.props.t("support.form.suspension-message-part-2") + this.props.associate.personalData.identificationNumber + this.props.t("support.form.suspension-message-part-3") + this.props.associate.personalData.nif + this.props.t("support.form.suspension-message-part-4") + address + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city + this.props.t("support.form.suspension-message-part-5") + this.props.ballot.ballotRef + this.props.t("support.form.suspension-message-part-6") + (this.state.contactType.code === SUSPENSION_REQUEST_OPTION.code ? this.props.t("support.form.suspension-message-part-7") : this.props.t("support.form.suspension-message-part-8")) + this.props.t("support.form.suspension-message-part-9") + (this.state.reason === null ? this.state.reasonDetail : this.state.reason.name) + this.props.t("support.form.suspension-message-part-10") + dd + '/' + mm + '/' + yyyy + this.props.t("support.form.suspension-message-part-11");
        }
        else if(isCloseSuspensionContactType(this.state.contactType)) {
            var dd = String(suspensionDate.getDate()).padStart(2, '0');
            var mm = String(suspensionDate.getMonth() + 1).padStart(2, '0');
            var yyyy = suspensionDate.getFullYear();
            
            return this.props.t("support.form.close-suspension-message-part-1") + this.props.associate.personalData.name + this.props.t("support.form.close-suspension-message-part-2") + this.props.associate.personalData.identificationNumber + this.props.t("support.form.close-suspension-message-part-3") + this.props.associate.personalData.nif + this.props.t("support.form.close-suspension-message-part-4") + address + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city + this.props.t("support.form.close-suspension-message-part-5") + this.props.ballot.ballotRef + this.props.t("support.form.close-suspension-message-part-6") + dd + '/' + mm + '/' + yyyy + this.props.t("support.form.close-suspension-message-part-7");
        }
        else {
            return this.state.message;
        }
    }

    uploadDocumentHandler(document) {
        let self = this;
        var reader = new FileReader();
        reader.readAsBinaryString(document[0]);

        reader.onload = function() {
            self.setState({
                documentAttachment: btoa(reader.result),
                documentAttachmentName: document[0].name,
                validUploadFile: true
            });
        };
    }

    render() {

        return (    
            <div className={isMobileOnly ? 'mgb-20' : 'mgb-80'}>
                <PageTitleComponent title={this.props.t("support.title")} />
                <div className="grid">
                    <div className='col-1'></div>
                    <div className="col-10">
                        { this.state.serverLoading ? 
                            <div className='container'>
                                <div className="col-12 t-align-center">
                                    <i className="mgt-100 mgb-100 pi pi-spin pi-spinner" style={{ fontSize: '4rem', color: '#0073aa' }}></i>
                                </div>
                            </div>
                            :
                            <div className="card p-fluid mgt-20">
                                <div className="field t-align-left">
                                    <label style={{fontSize:"14px"}} htmlFor="contact-type">{this.props.t("support.form.contact-type")}</label>
                                    <Dropdown id="contact-type" className={!this.state.validContactType ? "p-invalid" : null} style={{fontSize:"14px"}} value={this.state.contactType} onChange={(e) => this.onChange("contactType", e.value)} options={getContactTypeList(getLanguage(), this.props.registrationState) } optionLabel="name" placeholder={this.props.t("support.form.contact-type-placeholder")}></Dropdown>
                                    { this.state.validContactType ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                                </div>
                                {
                                    isSuspensionContactType(this.state.contactType) ?  
                                        <div className="field t-align-left">
                                            <label style={{fontSize:"14px"}} htmlFor="reason">{this.props.t("support.form.reason")}</label>
                                            <Dropdown id="reason" className={!this.state.validReason ? "p-invalid" : null} style={{fontSize:"14px"}} value={this.state.reason} onChange={(e) => this.onChange("reason", e.value)} options={getSuspensionReasonList(getLanguage())} optionLabel="name" placeholder={this.props.t("support.form.reason-placeholder")}></Dropdown>
                                            { this.state.validReason ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                                        </div>
                                        : null
                                }
                                {
                                    isSuspensionContactType(this.state.contactType) && isReasonOther(this.state.reason) ? 
                                        <div className="field t-align-left">
                                            <label style={{fontSize:"14px"}} htmlFor="reasonDetail">{this.props.t("support.form.reason-detail")}</label>
                                            <InputText value={this.state.reasonDetail} id="reasonDetail" type="text" onChange={(evt) => this.onChange("reasonDetail", evt.target.value)} />
                                            { this.state.validReasonDetail ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                                        </div>
                                        : null
                                }
                                {
                                    isSuspensionContactType(this.state.contactType) || isCloseSuspensionContactType(this.state.contactType) ? 
                                        <div className="field t-align-left">
                                            {
                                                isSuspensionContactType(this.state.contactType) ?
                                                    <label style={{fontSize:"14px"}} htmlFor="reason">{this.props.t("support.form.suspension-date")}</label>
                                                    :
                                                    <label style={{fontSize:"14px"}} htmlFor="reason">{this.props.t("support.form.close-suspension-date")}</label>
                                            }
                                            <Calendar dateFormat="dd/mm/yy" minDate={new Date()} value={this.state.suspensionDate} showIcon showButtonBar onChange={(evt) => this.onChange("suspensionDate", evt.target.value)} />
                                            { this.state.validSuspensionDate ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                                            { this.state.validSuspension ? null : <small className="p-error">{this.props.t("support.messages.active-suspension")}</small>  }
                                            { this.state.validQuotePayment ? null : <small className="p-error">{this.props.t("support.messages.quote-payment")}</small>  }
                                        </div>
                                        : null
                                }
                                {
                                   !isSuspensionContactType(this.state.contactType) && !isCloseSuspensionContactType(this.state.contactType) ? 
                                        <div className="field t-align-left">
                                            <label style={{fontSize:"14px"}} htmlFor="message">{this.props.t("support.form.message")}</label>
                                            <InputTextarea id="message" className={!this.state.validMessage ? "p-invalid" : null} value={this.state.message} style={{fontSize:"14px", resize:"none"}} onChange={(e) => this.onChange("message", e.target.value)} rows="8" />
                                            { this.state.validMessage ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        : null
                                }
                                {
                                    isSuspensionContactType(this.state.contactType) ?  
                                        <div className="field t-align-left">
                                            <label style={{fontSize:"14px"}}><b>{this.props.t("support.form.suspension-warning-title")}</b>{this.props.t("support.form.suspension-warning-description")}</label>
                                        </div>
                                        : null
                                }
                                {
                                    isCloseSuspensionContactType(this.state.contactType) ?  
                                        <div className="field t-align-left">
                                            <label style={{fontSize:"14px"}}><b>{this.props.t("support.form.close-suspension-warning-description")}</b>{this.props.t("support.form.suspension-warning-description")}</label>
                                        </div>
                                        : null
                                }
                                <div className='grid container'>
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <FileUpload mode="basic" 
                                                    accept="application/pdf" 
                                                    chooseLabel={this.props.t("support.form.upload-document")}
                                                    maxFileSize={5000000} 
                                                    uploadHandler={(evt) => this.uploadDocumentHandler(evt.files)} customUpload={true} auto={true}
                                                    onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                                {
                                                    this.state.documentAttachment !== null ? 
                                                        <span>{this.state.documentAttachmentName}</span> : null
                                                }
                                    </div>
                                    <div className='col-12 md:col-12 lg:col-6 t-align-right'>
                                        <Button label={this.props.t("general.submit")} style={{fontSize:"14px", width:"100px"}} className="mr-2 mb-2" onClick={() => this.submitSupportRequest()} />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className='col-1'></div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
    } 
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        ballot: state.profile.ballot,
        registrationState: state.authentication.registrationState,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(SupportPage)));